<script setup lang="ts">
  import { computed } from "vue";
  import { IconMenuDollar, Text } from "@ui-kit";
  import { useDeviceInfo } from "@plugins";
  import { useProfileOptions } from "@src/hooks";
  import { useUserInfoStore, useWidgetsStore } from "@src/store";
  import { default as MainPageAction } from "./MainPageAction.vue";

  const { deviceInfo } = useDeviceInfo();
  const { hasPermission } = useProfileOptions();
  const user_info_store = useUserInfoStore();
  const widgets_store = useWidgetsStore();

  const isAvailableAction = computed(() => {
    return (
      hasPermission("mobile.item_check_sales") &&
      deviceInfo?.value.isBarcodeScanner &&
      user_info_store.shop?.config.options.rfid_alarm
    );
  });
</script>

<template>
  <MainPageAction
    v-if="isAvailableAction"
    @click="() => widgets_store.open('check_sales')"
    data-testid="action-check-sales"
  >
    <template #icon>
      <IconMenuDollar />
    </template>
    <template #text>
      <Text font="body-regular-18" :wrap="false">{{ $t("Проверка продаж КСО") }}</Text>
    </template>
  </MainPageAction>
</template>
